import {type IUser, UserSource} from '../schema';

export const canResetPassword = (user?: IUser) =>
	!!user && user.userSource === UserSource.INTERNAL && !user.disabled;
